// @ts-check
/**
 * @module estrutura/models
 */

export class Estrutura {

	constructor( estruturaOrDispositivo = {} ) {
		if ( estruturaOrDispositivo == null ) {
			estruturaOrDispositivo = {};
		}
		/**
		 * @type {number}
		 */
		this.codigo = toIntegerOrNull( estruturaOrDispositivo.codigo );
		/**
		 * @type {number}
		 */
		this.numero = toIntegerOrNull( estruturaOrDispositivo.numero );
		/**
		 * @type {string}
		 */
		this.letra = estruturaOrDispositivo.letra || null;
		/**
		 * @type {boolean}
		 */
		this.complementar = toBoolean( estruturaOrDispositivo.complementar );
		/**
		 * @type {boolean}
		 */
		this.sub = toBoolean( estruturaOrDispositivo.sub );
		/**
		 * @type {boolean}
		 */
		this.numeracaoManual = toBoolean( estruturaOrDispositivo.numeracaoManual );
		/**
		 * @type {number}
		 */
		this.dispositivo = toIntegerOrNull( estruturaOrDispositivo.dispositivo ) || toIntegerOrNull( estruturaOrDispositivo );
		/**
		 * @type {boolean}
		 */
		this.topo = toBoolean( estruturaOrDispositivo.topo );
		/**
		 * @type {number}
		 */
		this.id = toIntegerOrNull( estruturaOrDispositivo.id );
	}
}

export class Dispositivo {

	/**
	 * @param dispositivo {any}
	 */
	constructor( dispositivo = null ) {
		if ( dispositivo == null || typeof dispositivo !== 'object' ) {
			dispositivo = {
				codigo: dispositivo
			}
		}

		/**
		 * @type {number}
		 */
		this.codigo = toIntegerOrNull( dispositivo.codigo );
		/**
		 * @type {string}
		 */
		this.descricao = dispositivo.descricao || null;
		/**
		 * @type {string}
		 */
		this.sigla = dispositivo.sigla || null;
		/**
		 * @type {string}
		 */
		this.estilo = dispositivo.estilo || null;
		/**
		 * @type {string}
		 */
		this.prefixo = dispositivo.prefixo || null;
		/**
		 * @type {number}
		 */
		this.condicao = toIntegerOrNull( dispositivo.condicao );
		/**
		 * @type {string}
		 */
		this.sufixo = dispositivo.sufixo || null;
		/**
		 * @type {string}
		 */
		this.sufixoCondicao = dispositivo.sufixoCondicao || null;
		/**
		 * @type {number}
		 */
		this.nivel = toIntegerOrNull( dispositivo.nivel );
		/**
		 * @type {boolean}
		 */
		this.temFilho = toBoolean( dispositivo.temFilho );
		/**
		 * @type {boolean}
		 */
		this.ext = toBoolean( dispositivo.ext );
		/**
		 * @type {string}
		 */
		this.numeracao = dispositivo.numeracao || null;
		/**
		 * @type {boolean}
		 */
		this.continuo = toBoolean( dispositivo.continuo );
		/**
		 * @type {boolean}
		 */
		this.ementa = toBoolean( dispositivo.ementa );
		/**
		 * @type {boolean}
		 */
		this.identificador = toBoolean( dispositivo.identificador );
		/**
		 * @type {boolean}
		 */
		this.quebrapagina = toBoolean( dispositivo.quebrapagina );
		/**
		 * @type {boolean}
		 */
		this.topo = toBoolean( dispositivo.topo );
		/**
		 * @type {boolean}
		 */
		this.reseta = toBoolean( dispositivo.reseta );
	}
}

/**
 *
 * @param {any} val
 * @returns {number}
 */
export function toIntegerOrNull( val ) {
	if ( /^-?[0-9]+$/.test( val ) ) {
		return +val;
	} else {
		return null;
	}
}

/**
 *
 * @param {any} val
 * @returns {boolean}
 */
export function toBoolean( val ) {
	return /^true$/.test( val );
}
